<template>
  <div class="home contenido">
    <div class="container">
    <HelloWorld 
        msg="Estamos listos para protegerte."
        idea="La vida es un reto constante, lo mismo trae alegrías que incertidumbre. En RMZ Asesores queremos que estés listo para vivirla sin límites; contamos con la fuerza del conocimiento en seguros y administración de riesgo para personas y empresas."
        btnurl="/seguros-venta-y-asesoria-individuos"
        btntitle="Conoce nuestros servicios"
        :imagen="imagen"
     />
     <Titulo titulo="Hablemos de acuerdos, no de pólizas" idea="Nuestro trabajo va más alla de prestarte un servicio. Es un compromiso con tus planes, que te acompaña en cada momento con una guía precisa para estar un paso adelante de lo que pase." />
     <div class="embed-responsive embed-responsive-16by9" data-aos="fade-up" data-aos-duration="1000">
        <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/uqzL58Y3HQY?rel=0" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
     </div>
     <Titulo titulo="Preparados para todos tus planes" />
     <BloqueFoto titulo="Seguros:<br />venta y asesoría" texto="Contamos con la asesoría que te acompaña y todo tipo de planes para proteger tu salud, tu vida, tus cosas y proyectos, para que vivas con tranquilidad." linkURL="/seguros-venta-y-asesoria-individuos" textoURL="Conoce más sobre la venta y asesoría en seguros" :imagen="imagen2" pos="fotoizquierda" color="azul" />
     <BloqueFoto titulo="Administración de<br />riesgos" texto="La gestión de riesgos ofrece planes que le dan certeza y continuidad a tu operación, ayudando a prevenir y reducir las situaciones que pueden salirse de control." linkURL="/administracion-de-riesgos" textoURL="Conoce más sobre la Administración de riesgos" :imagen="imagen3" pos="fotoderecha" color="morado" />
     <BloqueFoto titulo="Auditoría en seguros" texto="Una asesoría que revisa el presente de tus contratos, su eficacia ante los riesgos actuales y con ello revelar si tu organización está debidamente protegida." linkURL="/auditoria-en-seguros" textoURL="Conoce más sobre la Auditoría en seguros" :imagen="imagen4" pos="fotoizquierda" color="cafe" />
     <BloqueFoto titulo="Asesoría en siniestros" texto="La asesoría en siniestros trabaja con tu empresa para minimizar las pérdidas e inconvenientes ante los imponderables; ayudándote a prevenir y posteriormente a recuperar su operación." linkURL="/asesoria-en-siniestros" textoURL="Conoce más sobre la Asesoría en siniestros" :imagen="imagen8" pos="fotoderecha" color="azul2" />
     <Titulo titulo="Te ponemos un paso adelante" />
     <div class="bloqueAzul mx-3 mx-md-0">
        <div class="row justify-content-center">
            <div class="col-xl-5">
                <div class="row pl-xl-5 pr-xl-0 pt-5 pb-0 pt-xl-0">
                    <div class="col-2 py-3">
                        <img class="paloma" src="@/assets/images/paloma.svg" data-aos="fade-up" data-aos-duration="1000" />
                    </div>
                    <div class="col-10 py-3">
                        Preparados en todo lo concerniente a la seguridad y administración de riesgos.
                    </div>
                    <div class="col-2 py-3">
                        <img class="paloma" src="@/assets/images/paloma.svg" data-aos="fade-up" data-aos-duration="1000" />
                    </div>
                    <div class="col-10 py-3">
                        Conocimiento de tu contexto y cada detalle del seguro que más te conviene.
                    </div>
                    <div class="col-2 py-3">
                        <img class="paloma" src="@/assets/images/paloma.svg" data-aos="fade-up" data-aos-duration="1000" />
                    </div>
                    <div class="col-10 py-3">
                        Capacitación continua del equipo que te atiende y asesora.
                    </div>
                </div>
            </div>
            <div class="col-xl-5">
                <div class="row pr-xl-5 pl-0 pt-0 pb-0 pt-xl-0">
                    <div class="col-2 py-3">
                        <img class="paloma" src="@/assets/images/paloma.svg" data-aos="fade-up" data-aos-duration="1000" />
                    </div>
                    <div class="col-10 py-3">
                        Respuesta y seguimiento a cada proceso.
                    </div>
                    <div class="col-2 py-3">
                        <img class="paloma" src="@/assets/images/paloma.svg" data-aos="fade-up" data-aos-duration="1000" />
                    </div>
                    <div class="col-10 py-3">
                        Involucramiento: compromiso a largo plazo.
                    </div>
                    <div class="col-2 py-3">
                        <img class="paloma" src="@/assets/images/paloma.svg" data-aos="fade-up" data-aos-duration="1000" />
                    </div>
                    <div class="col-10 py-3">
                        Pasión: hacemos las cosas siempre con el corazón.
                    </div>
                    <div class="col-12 text-right pt-5 pb-5 pb-xl-0">
                        <img src="@/assets/images/estamos_preparados2.svg" class="estamosPreparados" data-aos="fade-up" data-aos-duration="1000" />
                    </div>
                </div>
            </div>
        </div>
     </div>
     </div>
     <div class="triangulo"></div>
     <div class="contenidoTriangulo">
         <Titulo titulo="Lo dicen nuestros clientes:" />
         <Clientes id="mensajesClientes" :items="items" />
         <div class="container relacionesComerciales">
             <Titulo titulo="Relaciones comerciales:" color="morado" />
             <div class="row m-0 px-lg-5 pt-lg-5 p-3 pt-4 pb-5">
                <div class="col-md-3 col-6 p-lg-5 p-3" data-aos="fade-up" data-aos-duration="1000">
                    <a href="https://www.auroquim.com.mx/" target="_blank"><img src="@/assets/images/relacionescolor-auroquim.png" class="img-fluid" /></a>
                </div>
                <div class="col-md-3 col-6 p-lg-5 p-3" data-aos="fade-up" data-aos-duration="1000">
                    <a href="http://www.equipromex.com/" target="_blank"><img src="@/assets/images/relacionescolor-equipromex.png" class="img-fluid" /></a>
                </div>
                <div class="col-md-3 col-6 p-lg-5 p-3" data-aos="fade-up" data-aos-duration="1000">
                    <a href="https://www.gopac.com.mx/" target="_blank"><img src="@/assets/images/relacionescolor-gopacsi.png" class="img-fluid" /></a>
                </div>
                <div class="col-md-3 col-6 p-lg-5 p-3" data-aos="fade-up" data-aos-duration="1000">
                    <a href="https://www.hipra.com/portal/es/hipra/home" target="_blank"><img src="@/assets/images/relacionescolor-hipra.png" class="img-fluid" /></a>
                </div>
                <div class="col-md-3 col-6 p-lg-5 p-3" data-aos="fade-up" data-aos-duration="1000">
                    <a href="https://www.tornillostacsa.com/" target="_blank"><img src="@/assets/images/relacionescolor-tacsa.png" class="img-fluid" /></a>
                </div>
                <div class="col-md-3 col-6 p-lg-5 p-3" data-aos="fade-up" data-aos-duration="1000">
                    <a href="https://induspac.com.mx/e/induspac/locations.htm" target="_blank"><img src="@/assets/images/relacionescolor-induspac.png" class="img-fluid" /></a>
                </div>
                <div class="col-md-3 col-6 p-lg-5 p-3" data-aos="fade-up" data-aos-duration="1000">
                    <a href="https://www.nucleodediagnostico.com/" target="_blank"><img src="@/assets/images/relacionescolor-nucleodediagnostico.png" class="img-fluid" /></a>
                </div>
                <div class="col-md-3 col-6 p-lg-5 p-3" data-aos="fade-up" data-aos-duration="1000">
                    <a href="https://www.silgan.com/" target="_blank"><img src="@/assets/images/relacionescolor-silgan.png" class="img-fluid" /></a>
                </div>
             </div>
         </div>
     </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Imagen from '@/assets/images/banner-header_00-homepage.png'
import Imagen2 from '@/assets/images/homepage2_01-seguros-venta-y-asesoria.jpg'
import Imagen3 from '@/assets/images/homepage2_02-administracion-de-riesgos.jpg'
import Imagen4 from '@/assets/images/homepage2_03-auditoria-en-seguros.jpg'
import Imagen8 from '@/assets/images/homepage2_04-asesoria-en-siniestros.jpg'
import Imagen5 from '@/assets/images/relacionescolor-induspac2.png'
import Imagen6 from '@/assets/images/relacionescolor-hipra.png'
import Imagen7 from '@/assets/images/relacionescolor-silgan.png'
import Titulo from '@/components/Titulo.vue'
import BloqueFoto from '@/components/BloqueFoto.vue'
import Clientes from '@/components/Clientes.vue'
export default {
  name: 'Home',
  data() {
      return {
          imagen: Imagen,
          imagen2: Imagen2,
          imagen3: Imagen3,
          imagen4: Imagen4,
          imagen8: Imagen8,
          items: [
            {'text': 'Tenemos más de 10 años trabajando en equipo, hemos logrando una relación de confianza con <strong>RMZ Asesores</strong>. Sabemos que estamos con los expertos, por el nivel de atención que durante este tiempo han proporcionado tanto a nivel personal como en cuestión empresarial. El servicio es personalizado y con seguimiento real, logrando el objetivo de solucionar nuestros requerimientos.', 'title': 'Natalia Ledón', 'puesto': 'CONTRALOR', 'imagen': Imagen5, 'frase': '10 AÑOS DE CONFIANZA.'},
            {'text': 'El servicio que hemos recibido de <strong>RMZ Asesores</strong> ha sido de total satisfacción, siempre enfocado en un bienestar integral para nuestra empresa, pues se toman el tiempo necesario para conocerla y ofrecer el producto que se ajuste a nuestras necesidades.', 'title': 'Brenda Vicario', 'puesto': 'FINANCIAL & ADMIN MANAGER', 'imagen': Imagen6, 'frase': '11 AÑOS DE CONFIANZA.'},
            {'text': 'Siempre han sido un proveedor confiable y honesto, tenemos la certeza que nos ayudara a buscar la opción que mejor se adecúe a nuestras necesidades en la compañía y con la calidez humana que caracteriza a sus servicios.', 'title': 'Alicia Velázquez', 'puesto': 'PLANT CONTROLLER', 'imagen': Imagen7, 'frase': '12 AÑOS DE CONFIANZA.'},
          ]
      }
  },
  components: {
    HelloWorld,
    Titulo,
    BloqueFoto,
    Clientes,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      muestraFooter: function(){
          this.$store.commit('muestraFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.muestraFooter();
      this.$store.commit('mideMenos', false);
      this.$store.commit('mideMas', true);
      this.$store.commit('estira', false);
  }
}
</script>
<style scoped>
.relacionesComerciales img {
    -webkit-filter: grayscale(1) opacity(.2);
    filter: grayscale(1) opacity(.5);
    border-right: 5px solid #999999;
    border-bottom: 5px solid #999999;
    cursor: pointer;
}
.relacionesComerciales img:hover {
    filter: none;
}
.contenido {
    min-height: 500px;
}
.bloqueAzul {
    color: #FFF;
    margin: 40px 0 80px 0;
    font-size: 14px;
}
.bloqueAzul .col-xl-5 {
    background: #08028A;
    padding: 70px 40px 40px 50px;
}
.bloqueAzul img.paloma {
    width: 24px;
}
img.estamosPreparados{
    height: 40px;
}
.triangulo {
    width: 100%;
    height: 100px;
    clip-path: polygon(50% 0, 0 100%, 100% 100%);
    background: #E6E7F4;
    margin-top: 150px;
}
.contenidoTriangulo {
    background: #E6E7F4;
    padding: 1px 0 150px 0;
}
.relacionesComerciales {
    padding: 1px 0 0 0;
    margin: 180px auto 0 auto;
    background: #FFF;
}
@media only screen and (max-width: 1199px){
    .bloqueAzul .col-xl-5 {
        padding: 0 40px 0 50px !important;
    }
    .triangulo {
        height: 50px;
    }
}
</style>
